import algoliasearch from 'algoliasearch/lite';

export const getPopularSearches = async (): Promise<Array<string>> => {
  try {
    const algoliaClient = algoliasearch(
      process.env.GATSBY_ALGOLIA_APP_ID as string,
      process.env.GATSBY_ALGOLIA_SEARCH_PUBLIC_KEY as string
    );

    const gatsbyAlgoliaSuggestionsIndex = algoliaClient.initIndex(
      `${process.env.GATSBY_ALGOLIA_INDEX!}_suggestions`
    );

    const searchSuggestions = await gatsbyAlgoliaSuggestionsIndex.search<{
      query: string;
    }>('');

    return searchSuggestions?.hits?.slice(0, 3).map(({ query }) => query);
  } catch (error) {
    console.error(`Error retrieving search suggestions`, error);

    return [];
  }
};
